import { CircularProgress, IconButton, styled, Tooltip } from "@mui/material";
import { cloneElement } from "react";
import { useSelector } from "react-redux";

const PrimaryIconButton = ({
  icon,
  onClick,
  disabled,
  color,
  width,
  height,
  size,
  tooltipTitle,
  loading,
  ...rest
}) => {
  const userState = useSelector(state => state?.userState);
  const theme = userState?.publisher?.theme_color;
  const adjustedIcon = cloneElement(
    loading ? <CircularProgress size={16} /> : icon,
    {
      style: { fontSize: size, color: "white" },
    }
  );
  return (
    <Tooltip title={tooltipTitle} placement="bottom">
      <CustomButton
        onClick={onClick}
        disabled={disabled}
        customColor={color || theme}
        customWidth={width}
        customHeight={height}
        size={size}
        {...rest}
      >
        {adjustedIcon}
      </CustomButton>
    </Tooltip>
  );
};

const CustomButton = styled(IconButton)(
  ({ customColor, customWidth, customHeight }) => ({
    backgroundColor: customColor || "#111827",
    textTransform: "none",
    height: customHeight || 30,
    width: customWidth || 30,
    borderRadius: 6,
    padding: 0,
    "&:hover": {
      backgroundColor: `${customColor || "#111827"}`,
      boxShadow: `0px 2px 4px ${customColor || "#111827"}`,
    },
    "&.Mui-disabled": {
      backgroundColor: `${customColor || "#111827"}`,
      opacity: 0.2,
    },
  })
);
export default PrimaryIconButton;
